// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/MemberSpecific/MemberSpecificUtils.jsx
import { 
    faUser, faCar, faBirthdayCake, faEnvelope, faPhone, faMapMarkerAlt, faIdCard, 
    faPlane, faShip, faDollarSign, faBuilding, faVenusMars, faGlobe, faSearch, 
    faBriefcase, faCalendarAlt, faStar, faBox, faCheckCircle, faClock, faHeart
  } from '@fortawesome/free-solid-svg-icons';
  
  // Define single source of allowed fields with labels, icons, and index IDs
  export const ALLOWED_FIELDS = {
    profile: {
      personalInfo: [
        { id: 1, key: 'user_id', label: 'User ID', icon: faIdCard },
        { id: 2, key: 'name', label: 'First Name', icon: faUser },
        { id: 3, key: 'sur_name', label: 'Last Name', icon: faUser },
        { id: 4, key: 'age', label: 'Age', icon: faBirthdayCake },
        { id: 5, key: 'birthday', label: 'Birthday', icon: faBirthdayCake },
        { id: 6, key: 'email', label: 'Email', icon: faEnvelope },
        { id: 7, key: 'telephone', label: 'Phone Number', icon: faPhone },
        { id: 8, key: 'location', label: 'Location', icon: faMapMarkerAlt }
      ],
      assetsIncome: [
        { id: 9, key: 'car_brand', label: 'Car Brand', icon: faCar },
        { id: 10, key: 'number_of_cars', label: 'Number of Cars', icon: faCar },
        { id: 11, key: 'private_car', label: 'Private Car', icon: faCar },
        { id: 12, key: 'private_airplane', label: 'Private Airplane', icon: faPlane },
        { id: 13, key: 'private_yacht', label: 'Private Yacht', icon: faShip },
        { id: 14, key: 'income', label: 'Income', icon: faDollarSign },
        { id: 15, key: 'net_worth', label: 'Net Worth', icon: faBuilding }
      ]
    },
    details: {
      personalInfo: [
        { id: 16, key: 'gender_label', label: 'Gender', icon: faVenusMars },
        { id: 17, key: 'nationality_label', label: 'Nationality', icon: faGlobe }
      ],
      preferences: [
        { id: 18, key: 'looking_for_label', label: 'Looking For', icon: faSearch },
        { id: 19, key: 'gender_match_label', label: 'Preferred Gender', icon: faHeart },
        { id: 20, key: 'nationality_match_label', label: 'Preferred Nationality', icon: faGlobe },
        { id: 21, key: 'occupation_match_label', label: 'Preferred Occupation', icon: faBriefcase }
      ],
      assetsIncome: [
        { id: 22, key: 'car_label', label: 'Car Type', icon: faCar },
        { id: 23, key: 'income_classes_label', label: 'Income Class', icon: faDollarSign }
      ]
    },
    packages: {
      packages: [
        { id: 24, key: 'date', label: 'Purchase Date', icon: faCalendarAlt },
        { id: 25, key: 'isHighlighted', label: 'Highlighted', icon: faStar },
        { id: 26, key: 'package', label: 'Package Name', icon: faBox },
        { id: 27, key: 'price', label: 'Price', icon: faDollarSign },
        { id: 28, key: 'status_name', label: 'Status', icon: faCheckCircle },
        { id: 29, key: 'time', label: 'Purchase Time', icon: faClock },
        { id: 30, key: 'user_id', label: 'User ID', icon: faIdCard }
      ]
    }
  };
  
  // Format key for display using custom label
  export const formatKey = (key, translations) => {
    // Find the field in ALLOWED_FIELDS to get its label
    let fieldLabel = key;
    Object.values(ALLOWED_FIELDS).forEach((section) => {
      Object.values(section).forEach((fields) => {
        const field = fields.find((f) => f.key === key);
        if (field && field.label) {
          fieldLabel = translations[field.key] || field.label;
        }
      });
    });
    // Fallback to formatted key if no label found
    return fieldLabel !== key ? fieldLabel : key
      .replace(/([A-Z])/g, ' $1')
      .replace(/_/g, ' ')
      .replace(/^./, (str) => str.toUpperCase());
  };
  
  // Format value for display
  export const formatValue = (value, key, translations, getSelectedLanguage) => {
    if (key && (key.startsWith('private_') || key === 'isHighlighted')) {
      return value ? (translations.yes || 'Yes') : (translations.no || 'No');
    }
    if (value === null || value === undefined || value === '') {
      return translations.notAvailable || 'N/A';
    }
    if (typeof value === 'string' && value.includes('GMT')) {
      try {
        return new Date(value).toLocaleDateString(getSelectedLanguage(), { year: 'numeric', month: 'long', day: 'numeric' });
      } catch (e) { /* ignore */ }
    }
    return String(value);
  };
  
  // Get icon for a field
  export const getIcon = (key) => {
    let icon = null;
    Object.values(ALLOWED_FIELDS).forEach((section) => {
      Object.values(section).forEach((fields) => {
        const field = fields.find((f) => f.key === key);
        if (field && field.icon) {
          icon = field.icon;
        }
      });
    });
    return icon;
  };